// src/Settings/DatabaseAdvisor/StatusTooltip.js
import React from 'react';
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: ({ color }) => color,
    color: '#fff',
    fontWeight: 600,
    fontSize: 11,
  },
  arrow: {
    color: ({ color }) => color,
  },
});

function StatusTooltip({ color, title, children }) {
  const classes = useStyles({ color });
  return (
    <Tooltip title={title} arrow classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}>
      {children}
    </Tooltip>
  );
}

export default StatusTooltip;
